import React from 'react'

import { BASE_URL, ICONS } from '../../constants'

import { useIncident } from '../hooks'

import styles from './IncidentListItem.module.css'

const IncidentListItem = ({ incidentId }) => {
  const [
    {
      name,
      type: { icon },
      visible,
    },
    { show, hide },
  ] = useIncident(incidentId)

  return (
    <li
      className={visible ? `${styles.active} ${styles.item}` : styles.item}
      onClick={visible ? hide : show}
    >
      <img
        className={styles.icon}
        alt={name}
        src={BASE_URL + ICONS.AI.BORDERLESS.DIR + icon}
      />
      <div className={styles.label}>{name}</div>
    </li>
  )
}
export default IncidentListItem
